<template>
    <div class="onboarding cf">

        <Navbar></Navbar>

        <div class="img-wrap">
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
            <div class="img"></div>
        </div>

        <div class="container">
            <ul class="pagination cf">
                <li>
                    <span>01</span>
                </li>
                <li>
                    <span>02</span>
                </li>
                <li>
                    <span>03</span>
                </li>
                <li>
                    <span>04</span>
                </li>
                <li>
                    <span>05</span>
                </li>
            </ul>

            <div class="cnt-wrap">
                <!-- first -->
                <div class="cnt">
                    <p class="title">
                        Dajemo ti priliku da svojim znanjem <span class="b">osvojiš nagradu!</span>
                    </p>
                    <p class="text">
                        Toni Milun liga je edukativna igra u kojoj ćemo redovito testirati tvoje znanje i nagrađivati najbolje igrače!
                    </p>
                    <div class="buttons cf">
                        <a href="#" class="button-1 blue" @click.prevent="nextSlide()"><span>Dalje</span></a>
                    </div>
                </div>

                <!-- second -->
                <div class="cnt">
                    <p class="title">
                        Potrebno je <span class="g">registrirati se</span> na Portalu
                    </p>
                    <p class="text">
                        Da bi ti sudjelovanje u Ligi bilo omogućeno.
                    </p>
                    <div class="buttons cf">
                        <a href="#" class="button-1 white l-arrow prev-button" @click.prevent="prevSlide()"><span>Nazad</span></a>
                        <a href="#" class="button-1 blue" @click.prevent="nextSlide()"><span>Dalje</span></a>
                    </div>
                </div>

                <!-- third -->
                <div class="cnt">
                    <p class="title">
                        <span class="r">Kada</span> se Liga održava?
                    </p>
                    <p class="text">
                        Ligu sačinjavaju pojedina kola (online kvizovi). Točan raspored kola potraži u Pravilima Lige.
                    </p>
                    <div class="buttons cf">
                        <a href="#" class="button-1 white l-arrow prev-button" @click.prevent="prevSlide()"><span>Nazad</span></a>
                        <a href="#" class="button-1 blue" @click.prevent="nextSlide()"><span>Dalje</span></a>
                    </div>
                </div>

                <!-- forth -->
                <div class="cnt">
                    <p class="title">
                        <span class="y">Kako</span> se igra?
                    </p>
                    <p class="text">
                        Svako kolo sastoji se od 6 pitanja iz četiri kategorije: matematike, engleskog, popularne znanosti i digitalnog društva. Rješavanje traje od 10 do 15 minuta.
                    </p>
                    <div class="buttons cf">
                        <a href="#" class="button-1 white l-arrow prev-button" @click.prevent="prevSlide()"><span>Nazad</span></a>
                        <a href="#" class="button-1 blue" @click.prevent="nextSlide()"><span>Dalje</span></a>
                    </div>
                </div>

                <!-- fifth -->
                <div class="cnt">
                    <p class="title">
                        Koje su <span class="b">nagrade?</span>
                    </p>
                    <p class="text">
                        Svako kolo Lige donosi ti bodove, a pobjednici Toni Milun Lige osvajaju vrijedne nagrade iz područja igre i edukacije, gaminga i pametnih uređaja. Provjeri nagrade za ovu sezonu u Pravilima Lige.
                    </p>
                    <div class="buttons cf">
                        <a href="#" class="button-1 white l-arrow prev-button" @click.prevent="prevSlide()"><span>Nazad</span></a>
                        <a href="#" class="button-1 blue" @click.prevent="nextSlide()"><span>Kreni</span></a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Navbar from '../components/Navbar'
import { STORAGE_KEY } from '../utils/storageKey'
import { TweenLite, TweenMax, Power2, Back, Power3 } from 'gsap'

export default {
    name: 'onboarding',
    data: function () {
        return {
            currentSlide: 0,
            maxSlides: null,
            minSlides: 0,
            animReady: true,
            // elements
            img: null,
            cnt: null,
            dotWrap: null,
            dot: null,
            dotChildren: null
        }
    },
    methods: {
        goHome () {
            localStorage.setItem(STORAGE_KEY.FIRST_TIME_ACCESSING, false)
            this.$router.push('/onboarding-guide')
        },
        finish () {
            this.goHome()
        },
        dotNext () {
            TweenMax.to(this.dot[this.currentSlide - 1], 0.6, {
                width: 7,
                delay: 0.2,
                ease: Power2.easeInOut
            })
            TweenMax.to(this.dot[this.currentSlide], 0.6, {
                delay: 0.2,
                width: 37,
                ease: Power2.easeInOut
            })
            // span
            TweenMax.to(this.dotChildren[this.currentSlide - 1], 0.6, {
                delay: 0.0,
                opacity: 0,
                display: 'none',
                y: -8,
                ease: Power2.easeInOut
            })
            TweenMax.to(this.dotChildren[this.currentSlide], 0.6, {
                delay: 0.4,
                opacity: 1,
                display: 'block',
                y: 0,
                ease: Power2.easeInOut
            })
        },
        dotPrev () {
            TweenMax.to(this.dot[this.currentSlide + 1], 0.6, {
                width: 7,
                delay: 0.2,
                ease: Power2.easeInOut
            })
            TweenMax.to(this.dot[this.currentSlide], 0.6, {
                delay: 0.2,
                width: 37,
                ease: Power2.easeInOut
            })
            // span
            TweenMax.to(this.dotChildren[this.currentSlide + 1], 0.6, {
                delay: 0.0,
                opacity: 0,
                display: 'none',
                y: -8,
                ease: Power2.easeInOut
            })
            TweenMax.to(this.dotChildren[this.currentSlide], 0.6, {
                delay: 0.4,
                opacity: 1,
                display: 'block',
                y: 0,
                ease: Power2.easeInOut
            })
        },
        nextSlide () {
            let self = this
            if (!this.animReady) {
                return
            }
            if (this.currentSlide + 1 <= this.maxSlides) {
                this.currentSlide++
            } else {
                this.finish()
                return
            }
            this.dotNext()

            // prev img
            TweenMax.to(this.img[this.currentSlide - 1], 0.6, {
                opacity: 0,
                rotationY: 70,
                x: -300,
                ease: Power3.easeIn,
                display: 'none',
                onStart: function () { self.animReady = false }
            })

            // current img
            TweenMax.set(this.img[this.currentSlide], {
                opacity: 0,
                rotationY: -70,
                x: 300,
                display: 'none'
            })

            TweenMax.to(this.img[this.currentSlide], 0.8, {
                opacity: 1,
                rotationY: 0,
                x: 0,
                delay: 0.4,
                ease: Back.easeOut,
                display: 'block',
                onComplete: function () { self.animReady = true }
            })

            // prev cnt
            TweenMax.staggerTo(this.cnt[this.currentSlide - 1].children, 0.6, {
                opacity: 0,
                x: -300,
                delay: 0.2,
                ease: Power3.easeIn
            }, 0.05, function () {
                // hide prev cnt wrap
                TweenMax.set(self.cnt[self.currentSlide - 1], {
                    opacity: 0,
                    display: 'none'
                })
                // show current cnt wrao
                TweenMax.set(self.cnt[self.currentSlide], {
                    opacity: 1,
                    display: 'block'
                })
            })

            // current cnt
            TweenMax.set(this.cnt[this.currentSlide].children, {
                opacity: 0,
                x: 300,
                display: 'none'
            })

            TweenMax.staggerTo(this.cnt[this.currentSlide].children, 0.8, {
                opacity: 1,
                x: 0,
                delay: 0.8,
                display: 'block',
                ease: Back.easeOut
            }, 0.05)
        },
        prevSlide () {
            let self = this
            if (!this.animReady) {
                return
            }
            if (this.currentSlide - 1 >= this.minSlides) {
                this.currentSlide--
            } else {
                return
            }
            this.dotPrev()

            // next img
            TweenMax.to(this.img[this.currentSlide + 1], 0.6, {
                opacity: 0,
                rotationY: -70,
                x: 300,
                ease: Power3.easeIn,
                display: 'none',
                onStart: function () { self.animReady = false }
            })

            // current img
            TweenMax.set(this.img[this.currentSlide], {
                opacity: 0,
                rotationY: 70,
                x: -300,
                display: 'none'
            })

            TweenMax.to(this.img[this.currentSlide], 0.8, {
                opacity: 1,
                rotationY: 0,
                x: 0,
                delay: 0.4,
                ease: Back.easeOut,
                display: 'block',
                onComplete: function () { self.animReady = true }
            })

            // prev cnt
            TweenMax.staggerTo(this.cnt[this.currentSlide + 1].children, 0.6, {
                opacity: 0,
                x: 300,
                delay: 0.2,
                ease: Power3.easeIn
            }, 0.05, function () {
                // hide prev cnt wrap
                TweenMax.set(self.cnt[self.currentSlide + 1], {
                    opacity: 0,
                    display: 'none'
                })
                // show current cnt wrao
                TweenMax.set(self.cnt[self.currentSlide], {
                    opacity: 1,
                    display: 'block'
                })
            })

            // current cnt
            TweenMax.set(this.cnt[this.currentSlide].children, {
                opacity: 0,
                x: -300,
                display: 'none'
            })

            TweenMax.staggerTo(this.cnt[this.currentSlide].children, 0.8, {
                opacity: 1,
                x: 0,
                delay: 0.8,
                display: 'block',
                ease: Back.easeOut
            }, 0.05)
        }
    },
    mounted: function () {
        this.img = document.querySelectorAll('.img-wrap .img')
        this.cnt = document.querySelectorAll('.cnt-wrap .cnt')
        this.dotWrap = document.querySelectorAll('.pagination')
        this.dot = document.querySelectorAll('.pagination li')
        this.dotChildren = document.querySelectorAll('.pagination li > span')
        this.maxSlides = this.cnt.length - 1

        // setup  ----------------------------------------------
        // img animations
        TweenLite.set(this.img, {
            opacity: 0,
            display: 'none'
        })

        // cnt animations
        TweenLite.set(this.cnt, {
            opacity: 0,
            display: 'none'
        })

        // dot animations
        TweenLite.set(this.dotChildren, {
            y: -8,
            opacity: 0,
            display: 'none'
        })

        // img
        TweenMax.to(this.img[this.currentSlide], 0.5, {
            opacity: 1,
            display: 'block'
        })
        // cnt
        TweenMax.to(this.cnt[this.currentSlide], 0.5, {
            opacity: 1,
            display: 'block'
        })
        // dot
        TweenLite.set(this.dot[this.currentSlide], {
            width: 37
        })
        TweenLite.set(this.dotChildren[this.currentSlide], {
            y: 0,
            opacity: 1,
            display: 'block'
        })
    },
    components: {
        Navbar
    }
}
</script>

<style lang="scss" scoped>
.onboarding {
    position: relative;
    text-align: left;
    padding-bottom: 40px;

    .img-wrap {
        perspective: 1000px;
        perspective-origin: 50%;
        position: relative;
        margin-bottom: 20px;
        width: 100%;
        height: 104vw;
        max-height: 522px;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;
        background-size: contain;
        background-position: 50%;
        background-repeat: no-repeat;
    }
    .img:nth-child(1) {
        background-image: url(~@/assets/img/sample/01.png);
    }
    .img:nth-child(2) {
        background-image: url(~@/assets/img/sample/02.png);
    }
    .img:nth-child(3) {
        background-image: url(~@/assets/img/sample/03.png);
    }
    .img:nth-child(4) {
        background-image: url(~@/assets/img/sample/04.png);
    }
    .img:nth-child(5) {
        background-image: url(~@/assets/img/sample/05.png);
    }
    .title {
        font-size: 28px;
        line-height: 30px;
        letter-spacing: -1px;
        font-family: 'mPlus';
        font-weight: 800;

        span.b {
            color: #65aaeb;
        }
        span.g {
            color: #90c744;
        }
        span.r {
            color: #fd4401;
        }
        span.y {
            color: #fbc701;
        }
    }
    .text {
        line-height: 22px;
        margin-bottom: 40px;
    }
    .pagination {
        margin-bottom: 20px;
    }
    .buttons {
        width: 95%;
    }
    .button-1:last-child {
        float: right;
        display: block;
        width: calc(100% - 32px);
        max-width: 140px;
        margin: auto;
    }
    .button-1:first-child {
        float: left;
        display: block;
        width: calc(100% - 32px);
        max-width: 140px;
        margin: auto;
    }
    .button-1 {
        display: block;
        width: calc(100% - 32px);
        max-width: 140px;
        margin: auto;
    }
}

@media only screen and (min-width: 800px) {
    .onboarding {
        position: static;
        padding: 0;
        max-width: 680px;
        width: calc(100% - 32px);
        margin: auto;

        > .container {
            float: left;
            width: 60%;
            margin-top: 70px;
        }
        .img-wrap {
            float: left;
            width: 40%;
            margin: auto;
            max-height: 390px;
        }
        .text {
            margin-bottom: 50px;
        }
        .button-1 {
            margin: 0;
        }
        .img {
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
}
@media only screen and (max-width: 380px) {
    .onboarding {
        .button-1:last-child {
            max-width: 120px;
        }
        .button-1:first-child {
            max-width: 120px;
        }
        .button-1 {
            max-width: 120px;
        }
    }
}
</style>
